// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import type { AppLocale } from "./appLocale";

let currentLocale: AppLocale = "en";

export function getCurrentAppLocale(): AppLocale {
  return currentLocale;
}

export function setCurrentAppLocale(locale: AppLocale): void {
  currentLocale = locale;
}
